var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmergency(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 291.648 291.648"
    },
    xmlSpace: "preserve",
    width: 100,
    height: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "orangered",
    d: "M76.956 72.462h-1.409V46.083c0 -14.087 -11.46 -25.547 -25.547 -25.547S24.454 31.996 24.454 46.083v26.379h-1.409c-5.746 0 -10.421 4.675 -10.421 10.421v13.688c0 1.894 1.535 3.429 3.429 3.429h67.897c1.894 0 3.429 -1.535 3.429 -3.429v-13.688c-0.001 -5.746 -4.675 -10.421 -10.422 -10.421zM31.311 46.083c0 -10.305 8.384 -18.689 18.689 -18.689s18.689 8.384 18.689 18.689v26.379H31.311v-26.379zm49.209 47.059H19.48v-10.259c0 -1.965 1.599 -3.564 3.564 -3.564H76.956c1.965 0 3.564 1.599 3.564 3.564v10.259z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "blue",
    d: "M50 13.715c1.894 0 3.429 -1.535 3.429 -3.429V3.429c0 -1.894 -1.535 -3.429 -3.429 -3.429s-3.429 1.535 -3.429 3.429v6.857c0 1.894 1.535 3.429 3.429 3.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "blue",
    d: "M19.457 24.358c0.67 0.67 1.547 1.004 2.424 1.004s1.755 -0.335 2.424 -1.004c1.339 -1.339 1.339 -3.51 0 -4.849l-4.848 -4.849c-1.339 -1.339 -3.51 -1.339 -4.849 0 -1.339 1.339 -1.339 3.51 0 4.849l4.849 4.849z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "blue",
    d: "M78.118 25.362a3.417 3.417 0 0 0 2.424 -1.004l4.849 -4.849c1.339 -1.339 1.339 -3.51 0 -4.849 -1.339 -1.339 -3.51 -1.339 -4.849 0l-4.848 4.849c-1.339 1.339 -1.339 3.51 0 4.849a3.419 3.419 0 0 0 2.424 1.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "grey",
    d: "M50 31.143c-8.238 0 -14.941 6.702 -14.941 14.941 0 1.894 1.535 3.429 3.429 3.429s3.429 -1.535 3.429 -3.429c0 -4.457 3.626 -8.083 8.083 -8.083 1.894 0 3.429 -1.535 3.429 -3.429s-1.535 -3.429 -3.429 -3.429z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergency);
export default __webpack_public_path__ + "static/media/emergency.d6da1025eb3b8a250545417105db2808.svg";
export { ForwardRef as ReactComponent };